import AuthLink from "./AuthLink";

export default AuthLink;
